import { FC, useState } from 'react';
import { ReactComponent as NoPhotoIcon } from 'assets/noPhoto.svg';
import { IAvatarIconProps } from './types';
import styles from './avatarIcon.module.scss';

export const AvatarIcon: FC<IAvatarIconProps> = ({ avatar, name, size, id, styleProps }) => {
  const [isImg, setIsImg] = useState(!!avatar);
  return (
    <div
      className={avatar ? styles.imgWarp : styles.iconWrap}
      id={id}
      style={{ ...styleProps, maxWidth: size, height: size, width: size, minWidth: size }}>
      {isImg ? (
        <img
          src={avatar || ''}
          width={size}
          height={size}
          alt={name}
          id={id + 'Icon'}
          loading='lazy'
          className={styles.image}
          onError={() => {
            setIsImg(false);
          }}
        />
      ) : (
        <NoPhotoIcon id={id + 'Icon'} className={styles.icon} width={size} height={size} />
      )}
    </div>
  );
};
